import StrokePropertiesIcon from '@atlaskit/icon-lab/core/stroke-properties';
import React from 'react';

export const SvgLineThickness = () => (
  <StrokePropertiesIcon label="" testId="ads-refreshed-icon" />
);
